import { VehicleDictionaryModel, VehicleModel } from '@/lib/models/vehicle/types';

export const getVehicleDetails = ({
  vehicleIds,
  vehicles,
}: {
  vehicleIds: string[];
  vehicles: VehicleDictionaryModel;
}): VehicleModel[] => {
  return vehicleIds.map((vehicleId) => vehicles[vehicleId]);
};
